/** From Flutter `app_fr.arb` — privacyPolicy* / termsOfService*, updated structure. */
export const legalMessagesFr = {
  privacy: {
    pageTitle: "Politique de confidentialité",
    lastUpdated: "Dernière mise à jour : 1 juin 2026",
    introduction: {
      title: "Introduction",
      body: "WasOK est une application locale d’aide aux achats conçue pour aider les utilisateurs à se souvenir des produits qu’ils ont déjà achetés, évalués ou commentés.\n\nCette Politique de confidentialité explique quelles informations sont traitées lors de l’utilisation de l’application, comment les données sont stockées et comment certains services tiers peuvent fonctionner.",
    },
    dataStored: {
      title: "Données stockées par l’application",
      body: "WasOK stocke localement sur votre appareil les informations suivantes :\n\n• codes-barres des produits scannés\n• noms et détails des produits saisis par l’utilisateur\n• notes et commentaires\n• listes de courses\n• catégories de produits\n• prix et informations des magasins\n• photos de produits et de magasins\n\nVos données produits et photos ne sont pas téléchargées sur les serveurs de WasOK.",
    },
    permissions: {
      title: "Autorisations utilisées",
      camera: {
        title: "Appareil photo",
        body: "L’accès à l’appareil photo permet de :\n\n• scanner les codes-barres\n• prendre des photos des produits",
      },
      photos: {
        title: "Photos et contenu multimédia",
        body: "L’accès aux photos ou à la galerie est utilisé uniquement lorsque vous :\n\n• joignez des images aux produits\n• restaurez des sauvegardes contenant des photos",
      },
      files: {
        title: "Accès aux fichiers et au stockage",
        body: "L’accès aux fichiers peut servir à :\n\n• exporter des fichiers de sauvegarde\n• importer des sauvegardes choisies par l’utilisateur\n• partager des listes de courses ou des sauvegardes",
      },
    },
    backup: {
      title: "Sauvegarde et export",
      body: "WasOK permet de créer des fichiers de sauvegarde avec les données de l’application et, en option, les photos.\n\nLes fichiers de sauvegarde sont créés localement sur votre appareil et peuvent être enregistrés ou partagés via les services que vous choisissez, par exemple :\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• stockage local de l’appareil\n\nWasOK ne téléverse pas les sauvegardes sur ses propres serveurs.",
      onlineProductLookup: {
        title: "Recherche produit en ligne",
        body: "Lorsque la recherche en ligne par code-barres est activée dans les préférences, WasOK peut envoyer uniquement le numéro du code-barres scanné à des bases publiques (comme Open Food Facts) pour suggérer un nom et une marque. WasOK n’envoie pas vos notes, commentaires, photos, listes d’achats, catégories, informations magasin ni sauvegardes. Vous pouvez désactiver cette option à tout moment dans les préférences.",
      },
    },
    advertising: {
      title: "Publicité et services tiers",
      intro:
        "WasOK utilise des services tiers sélectionnés pour fournir certaines fonctionnalités.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob est utilisé pour afficher des publicités dans l’application.\n\nGoogle et ses partenaires peuvent traiter des informations telles que :\n\n• identifiants publicitaires\n• informations sur l’appareil\n• adresse IP\n• données de diagnostic et d’utilisation\n\nDans certaines régions, le consentement de l’utilisateur peut être demandé avant d’afficher des annonces personnalisées.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK utilise Firebase Crashlytics pour identifier les plantages et améliorer la stabilité de l’application.\n\nLes rapports de plantage peuvent inclure des informations techniques telles que :\n\n• modèle de l’appareil\n• version du système d’exploitation\n• version de l’application\n• diagnostics de plantage\n\nLes rapports de plantage n’incluent pas intentionnellement vos évaluations, notes, listes de courses ou photos de produits.",
      },
      externalProductDatabases: {
        title: "Bases de données produits externes",
        body: "La recherche par code-barres peut utiliser des bases de données produits externes pour récupérer des informations produit.\n\nPour en savoir plus, consultez les politiques de confidentialité des fournisseurs concernés.",
      },
    },
    dataSecurity: {
      title: "Sécurité des données",
      body: "WasOK stocke les données de l’application localement sur votre appareil via les mécanismes de stockage fournis par le système d’exploitation.\n\nBien que des mesures raisonnables soient prises pour protéger les données locales de l’application, aucun mode de stockage électronique n’est totalement sûr.\n\nLes utilisateurs sont responsables de conserver des sauvegardes des données importantes s’ils le souhaitent.",
    },
    children: {
      title: "Confidentialité des enfants",
      body: "WasOK ne s’adresse pas aux enfants de moins de 13 ans.",
    },
    notifications: {
      title: "Notifications",
      body: "WasOK peut éventuellement créer des notifications locales sur votre appareil pour vous rappeler d’évaluer des produits après l’achat.\n\nCes notifications sont générées et planifiées localement sur votre appareil et ne nécessitent ni compte ni serveur distant.\n\nVous pouvez désactiver les notifications à tout moment via les réglages de votre appareil ou dans l’application, le cas échéant.",
    },
    yourControl: {
      title: "Votre contrôle sur les données",
      body: "Vous pouvez :\n\n• modifier ou supprimer les produits enregistrés à tout moment\n• effacer les données de l’application sur votre appareil\n• désinstaller l’application\n• exporter des sauvegardes de vos données",
    },
    changes: {
      title: "Modifications de cette politique",
      body: "Cette Politique de confidentialité peut être mise à jour périodiquement.\n\nLes changements prennent effet lorsque la version mise à jour est publiée.",
    },
    contact: {
      title: "Contact",
      body: "Pour toute question concernant cette Politique de confidentialité, contactez :\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Conditions d’utilisation",
    lastUpdated: "Dernière mise à jour : 1 juin 2026",
    acceptance: {
      title: "Acceptation des conditions",
      body: "En téléchargeant, installant ou utilisant WasOK, vous acceptez ces Conditions d’utilisation.\n\nSi vous n’acceptez pas ces Conditions, vous ne devez pas utiliser l’application.",
    },
    license: {
      title: "Licence",
      body: "WasOK vous accorde une licence limitée, non exclusive, non transférable et révocable pour utiliser l’application conformément à ces Conditions.",
    },
    acceptableUse: {
      title: "Usage autorisé",
      body: "Vous acceptez de ne pas :\n\n• utiliser l’application de manière abusive\n• perturber le fonctionnement de l’application\n• tenter de rétroconcevoir ou de modifier l’application\n• utiliser l’application en violation des lois ou règlements applicables",
    },
    localData: {
      title: "Données locales et sauvegardes",
      body: "WasOK stocke les données utilisateur localement sur l’appareil.\n\nLes utilisateurs sont responsables de conserver des sauvegardes des données importantes s’ils le souhaitent.\n\nMême si des fonctions de sauvegarde et de restauration peuvent être proposées, WasOK ne garantit pas l’absence de perte, de corruption ou de défaillance des données stockées.",
    },
    advertisements: {
      title: "Publicités",
      body: "L’application peut afficher des publicités fournies par des partenaires publicitaires tiers, dont Google AdMob.",
    },
    noWarranty: {
      title: "Aucune garantie",
      body: "WasOK est fourni « tel quel » et « selon disponibilité » sans garantie d’aucune sorte, expresse ou implicite.\n\nNous ne garantissons pas que :\n\n• l’application soit toujours disponible\n• l’application soit exempte d’erreurs\n• il n’y ait jamais de perte de données\n• toutes les fonctionnalités fonctionnent sans interruption sur tous les appareils",
    },
    limitationLiability: {
      title: "Limitation de responsabilité",
      body: "Dans la mesure maximale permise par la loi, WasOK et ses développeurs ne seront pas responsables de :\n\n• perte de données\n• perte de profits\n• problèmes liés à l’appareil\n• dommages indirects ou consécutifs\n• interruptions résultant de l’utilisation ou de l’impossibilité d’utiliser l’application",
    },
    thirdParty: {
      title: "Services tiers",
      body: "Certaines fonctions ou contenus peuvent dépendre de services tiers, y compris des fournisseurs publicitaires et des services externes de stockage ou de partage choisis par l’utilisateur.\n\nWasOK n’est pas responsable des services tiers ni de leurs politiques.",
    },
    productInformation: {
      title: "Informations produit",
      body: "Certaines informations produit peuvent provenir de services tiers de recherche par code-barres.\n\nWasOK ne garantit pas l’exactitude, l’exhaustivité, la disponibilité ou la pertinence des informations fournies par des sources de données externes.\n\nLes utilisateurs doivent vérifier eux-mêmes les informations produit le cas échéant.",
    },
    changesApp: {
      title: "Modifications de l’application",
      body: "WasOK peut être modifié, mis à jour, suspendu ou interrompu à tout moment sans préavis.",
    },
    changesTerms: {
      title: "Modifications de ces Conditions",
      body: "Ces Conditions peuvent être mises à jour périodiquement.\n\nLa poursuite de l’utilisation de l’application après l’entrée en vigueur des mises à jour vaut acceptation des Conditions révisées.",
    },
    contact: {
      title: "Contact",
      body: "Pour toute question sur ces Conditions, contactez :\n\nsupport@wasok.app",
    },
  },
};
